import React from 'react';
import ReactDOM from 'react-dom/client';
import Split from 'react-split';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { ReactComponent as Resize } from '../../../../assets/common-assets/Resize.svg';
import './Resize.css';

const ResizeGrid = (props) => {
  const { children, setDimensions, isSmallScreen } = props;
  const handleResize = (newSizes) => {
    setDimensions(newSizes);
  };
  const minSize1 = window.innerWidth * 0.29;

  if (isSmallScreen) {
    return (
      <Grid container columns={{ xs: 4, sm: 7, md: 12 }}>
        {React.Children.map(children, (child) => (
          <Grid item xs={12}>
            {child}
          </Grid>
        ))}
      </Grid>
    );
  }

  return (
    <Split
      sizes={[66, 34]}
      minSize={minSize1}
      gutterSize={0}
      direction="horizontal"
      className="split"
      onDrag={handleResize}
      gutter={(index, direction) => {
        const gutter = document.createElement('div');
        gutter.className = `gutter gutter-${direction}`;
        // Create a container for the Material UI icon
        const iconContainer = document.createElement('div');
        iconContainer.className = 'gutter-icon';

        const root = ReactDOM.createRoot(iconContainer);
        root.render(<Resize />);

        gutter.appendChild(iconContainer);
        return gutter; /* Return the gutter element */
      }}
    >
      {children}
    </Split>
  );
};

ResizeGrid.propTypes = {
  children: PropTypes.element.isRequired,
  setDimensions: PropTypes.func.isRequired,
  isSmallScreen: PropTypes.bool.isRequired,
};

export default ResizeGrid;
